import React from 'react';


const {
    Provider: ListProvider,
    Consumer: ListConsumer
} = React.createContext();

export {
    ListProvider,
    ListConsumer
};